<template>
  <div class="verification-content" style="height: 400px">
    <div class="left-section">
      <div class="upload-item">
        <div class="upload-box">
          <a-icon type="plus-circle" class="upload-icon" />
          <span>请上传授权委托书</span>
        </div>

        <div class="clearfix">
          <a-upload
            action="https://api.jssyjt.net/external-service-center/uploadFile/companyAuthorization"
            :headers="uploadHeaders"
            list-type="picture-card"
            :file-list="companyAuthorization"
            @preview="handlePreview"
            @change="handleCompanyAuthorizationChange"
            :multiple="false"
            :show-upload-list="true"
            accept=".jpg,.png"
            :data="{ idCardSide: 'front' }"
          >
            <div v-if="companyAuthorization.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">请上传图片</div>
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="previewHandleCancel"
          >
            <img alt="授权委托书" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>
        <div class="error-msg" style="margin-top: 15px">
          <span>温馨提示，授权委托书仅支持上传图片</span>
        </div>
      </div>
    </div>

    <!-- 分割线 -->
    <div class="vertical-divider"></div>

    <!-- 右侧表单 -->
    <div class="right-section">
      <div style="display: flex; flex-direction: column; align-items: center">
        <div class="notice-title">注意事项</div>

        <ul class="notice-list">
          <li>请核对授权委托书信息正确</li>
          <li>请确保授权委托书已盖公司章</li>
          <li>请确认上传的委托书为真实有效</li>
        </ul>
      </div>
      <a-form-model
        :model="formData"
        :rules="rules"
        ref="baseForm"
        layout="horizontal"
        class="auth-form"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-model-item label="授权期限" prop="authorizationPeriod">
          <a-select v-model="formData.authorizationPeriod" placeholder="请选择">
            <a-select-option :value="1">长期有效</a-select-option>
            <a-select-option :value="2">选择时间</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item
          v-if="formData.authorizationPeriod == 2"
          label="授权到期日期"
          prop="authorizationExpirationDate"
        >
          <a-date-picker
            style="width: 100%"
            placeholder="请选择授权到期日期"
            :disabled-date="disabledDate"
            v-model="formData.authorizationExpirationDate"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import storage from "store";
import { ACCESS_TOKEN } from "@/store/mutation-types";
export default {
  computed: {
    uploadHeaders() {
      const token = storage.get(ACCESS_TOKEN);
      return {
        Authorization: token ? token : "",
      };
    },
  },
  data() {
    return {
      companyAuthorization: [],
      previewVisible: false,
      previewImage: "",
      formData: {
        authorizationPeriod: 1,
        authorizationExpirationDate: undefined,
      },
      rules: {
        authorizationPeriod: [{ required: true, message: "请选择授权期限" }],
        authorizationExpirationDate: [
          { required: true, message: "请选择授权到期日期" },
        ],
      },
    };
  },
  watch: {},
  methods: {
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    //上传
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },

    //上传企业授权书
    handleCompanyAuthorizationChange({ fileList }) {
      console.log(fileList);
      fileList = fileList.map((item) => {
        if (item.response != null) {
          if (item.response.code == "200") {
            return {
              uid: item.uid,
              name: item.name,
              status: "done",
              url: item.response.data,
            };
          } else {
            return {
              uid: item.uid,
              name: item.name,
              status: "error",
              url: undefined,
            };
          }
        } else {
          return item;
        }
      });
      this.companyAuthorization = fileList;
    },

    previewHandleCancel() {
      this.previewVisible = false;
    },

    validateForSubmit() {
      return new Promise((resolve) => {
        // 1️⃣ 校验营业执照是否上传成功
        const uploaded =
          this.companyAuthorization.length > 0 &&
          this.companyAuthorization.every((f) => f.status === "done");

        if (!uploaded) {
          this.$notification.warning({
            message: "注意",
            description: "请上传授权委托书",
            duration: 4,
          });
          resolve(false);
          return;
        }

        // 2️⃣ 校验表单
        this.$refs.baseForm.validate((valid) => {
          if (!valid) {
            this.$notification.warning({
              message: "注意",
              description: "请先完善企业信息",
              duration: 4,
            });
            resolve(false);
            return;
          }

          // ✅ 全部通过
          resolve({
            valid: true,
            data: {
              ...this.formData,
              companyAuthorization: this.companyAuthorization,
            },
          });
        });
      });
    },
  },
};
</script>

<style scoped>
.identity-verification {
  padding: 20px;
}

.verification-content {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.qr-section {
  text-align: center;
}

.left-section {
  width: 48%;
}

.right-section {
  width: 48%;
}

.vertical-divider {
  width: 1px;
  background-color: #e8e8e8;
  margin: 0 20px;
}

.upload-item {
  margin-bottom: 20px;
  margin-top: 10px;
}

.upload-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.upload-icon {
  font-size: 24px;
  color: #1890ff;
  margin-right: 10px;
}

.upload-btn {
  margin-top: 10px;
}

.personal-info {
  background-color: #f9f9f9;
  padding: 10px;
  border-radius: 5px;
}

.info-item {
  display: flex;
  margin-bottom: 24px;
}

.label {
  font-weight: bold;
  margin-right: 10px;
}

.error-msg {
  color: red;
  font-size: 12px;
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
/* 输入框高度统一 */
.right-section /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}

/* ---- 右侧整体 ---- */
.auth-right {
  width: 48%;
  padding: 20px 30px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: center; /* ⭐ 水平居中关键 */
}

/* 标题 */
.notice-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}

/* 注意事项列表 */
.notice-list {
  margin: 0;
  padding-left: 18px;
  margin-bottom: 30px;
}

.notice-list li {
  font-size: 14px;
  color: #666;
  line-height: 26px;
}

/* 表单样式 */
.auth-form /deep/ .ant-form-item-label label {
  font-weight: 500;
  color: #333;
}

.auth-form /deep/ .ant-select-selection--single {
  height: 32px !important;
}

.auth-form /deep/ .ant-select-selection__rendered {
  line-height: 32px !important;
}

/* 提交按钮 */
.submit-box {
  margin-top: 20px;
}

.submit-btn {
  width: 120px;
  height: 36px;
  font-size: 14px;
  border-radius: 4px;
}
</style>